// frontend/src/landing/components/Section.tsx
import React from "react";

type Props = {
  id?: string;
  title?: React.ReactNode;
  eyebrow?: React.ReactNode;
  badge?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
};

export default function Section({
  id,
  title,
  eyebrow,
  badge,
  children,
  className,
}: Props) {
  return (
    <section className={`zg-section ${className ?? ""}`.trim()} id={id}>
      <div className="zg-container">
        {(eyebrow || badge) && (
          <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
            {eyebrow && (
              <div
                style={{
                  fontSize: 12,
                  letterSpacing: 0.6,
                  textTransform: "uppercase",
                  opacity: 0.75,
                }}
              >
                {eyebrow}
              </div>
            )}
            {badge && (
              <span
                style={{
                  fontSize: 12,
                  padding: "4px 8px",
                  borderRadius: 999,
                  border: "1px solid var(--pane-border)",
                  background: "var(--pane-bg)",
                }}
              >
                {badge}
              </span>
            )}
          </div>
        )}

        {title && <h2 className="zg-h2">{title}</h2>}
        {children}
      </div>
    </section>
  );
}